import React from "react";
import { Modal } from "antd";
import I18, { i18Get } from '../../i18';
import { connect } from 'react-redux';
import {Spinner, Button} from '../../kado/components';
import renderHTML from 'react-render-html';
import { getTrans } from "../../kado/utils";
const FinishModal = ({ isOpen, onClose, onConfirm, assessments, }) => {
  const selectedAss = assessments.assList.find((a) => a.selected);

  const selectedQA = assessments.selectedAssQA || [];

  const isAnswered = (ans) => {
    if (!ans) return false;

    return (
      ans.option || ans.textAns || ans.floatAns || (ans.mOptions && ans.mOptions.length > 0)
    );
  };

  // const total = selectedQA.length;
  let total = 0;

  selectedAss.questionnaires.forEach((qstnr) => {
    qstnr.sections.forEach((sec) => {
      sec.questions.forEach(() => {
        total++;
      });
    });
  });

  const completed = selectedQA.filter((q) => isAnswered(q.answer)).length;

  const questionnaireSummary = selectedAss.questionnaires.map((qstnr) => {
    let totalQ = 0;
    let answeredQ = 0;

    qstnr.sections.forEach((sec) => {
      sec.questions.forEach((q) => {
        totalQ++;

        const found = selectedQA.find((x) => x.uuid === q.uuid);

        if (
          found &&
          isAnswered(found.answer)
        ) {
          answeredQ++;
        }
      });
    });

    return {
      title: qstnr.title,
      total: totalQ,
      answered: answeredQ,
    };
  }
  );

  return (
    <Modal
      className="finsih-modal"
      visible={isOpen}
      footer={null}
      onCancel={onClose}
      closable={false}
      centered
      width={520}
      bodyStyle={{
        padding: "0px",
        height: "720px",
        overflow: "hidden",
        borderRadius: "24px",
      }}
    >
      <div
        style={{ height: "720px", display: "flex", flexDirection: "column", background: "#fff" }}>
        <div
          style={{ padding: "20px 18px", flex: 1, overflowY: "auto", }}>
          <div
            style={{ fontSize: "22px", lineHeight: "38px", fontWeight: "500", marginBottom: "24px", marginTop: "20px", }}
            className="heading"
          >
            {i18Get("You have successfully completed", {t: total, c: completed})}
          </div>


          <div
            style={{ display: "flex", flexDirection: "column", gap: "12px", }}>
            {questionnaireSummary.map(
              (item, i) => (
                <div
                  key={i}
                  style={{ border: "1px solid #212529", borderRadius: "8px", minHeight: "58px", height: 'auto', display: "flex", alignItems: "center", justifyContent: "space-between", padding: "2px 14px", background: "#fff", }}>
                  <div
                    style={{ display: "flex", alignItems: "center", gap: "10px", flex: 1, }}>
                    <img
                      src={item.answered === item.total ? "/images/fulltick.png" : "/images/halftick.png"}
                      alt="status"
                      style={{ width: "18px", height: "18px", }} />

                    <span style={{ fontSize: "18px", paddingRight: "8px", fontWeight: "400",wordBreak: 'break-word', overflowWrap: 'break-word', flex: 1 }}> {renderHTML(getTrans(item, 'title') || '')} </span>
                  </div>
                  <div
                    style={{ fontSize: "18px", fontWeight: "400"}}>
                    {item.answered}/  {item.total}
                  </div>
                </div>
              )
            )}
          </div>
        </div>

        <div
          style={{ padding: "18px", background: "#fff", }}>
          <div
            style={{ paddingTop: "18px", borderTop: "1px solid #EAEAEA", background: "#fff", display: "flex", gap: "12px", }}>
            <Button
              onClick={onClose}
            >
              {i18Get('Back and Edit')}
            </Button>
            <Button
              className={'btn-active'}
              onClick={onConfirm}
              color={"green"}
              disabled={assessments.isFinishAssessmentCompleted === 'PENDING'}
              >
              {assessments.isFinishAssessmentCompleted === 'PENDING' && (<Spinner />)}
              {i18Get('Finish')}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default connect(store => ({
  assessments: store.assessments,
  translations: store.translations,
}))(FinishModal);